import type { HierarchyRectangularNode } from '@visx/hierarchy/lib/types.js';
import { useEffect } from 'react';

import { useSetState } from '../store/selectors.js';
import type { ClusterNode, LeafNode } from '../types/guards/node-guards.js';
import type { TreeMapState } from '../types/state.js';

export const useSetHierarchyNodes = (
  clusters: HierarchyRectangularNode<ClusterNode>[],
  leafs: HierarchyRectangularNode<LeafNode>[],
) => {
  const setState = useSetState();

  useEffect(() => {
    setState((prev: TreeMapState) => ({
      ...prev,
      hierarchyLeafNodes: leafs,
      hierarchyClusterNodes: clusters,
    }));
  }, [leafs, clusters, setState]);
};
